// redux/actions/abogados/abogados.js
import axios from "axios";
import {
  FETCH_ABOGADOS_FAILURE,
  FETCH_ABOGADOS_SUCCESS,
} from "./types";
import { PATH } from "../../utils";

const SESSION_EXPIRED = "SESSION_EXPIRED";
const API_BASE = `${PATH}`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { "Content-Type": "application/json" },
});

const authHeader = () => {
  const token = localStorage.getItem("tokenadmin") || localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const clearTokens = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("tokenadmin");
};

const handleApiError = (dispatch, error, fallbackMsg) => {
  if (error?.response?.status === 401) {
    clearTokens();
    if (dispatch) dispatch({ type: SESSION_EXPIRED });
    return "Tu sesión ha expirado. Autentícate nuevamente.";
  }
  return (
    error?.response?.data?.detail ||
    error?.response?.data?.message ||
    error?.message ||
    fallbackMsg
  );
};

const fetchAbogadosSuccess = (payload) => ({
  type: FETCH_ABOGADOS_SUCCESS,
  payload,
});

const fetchAbogadosFailure = (message) => ({
  type: FETCH_ABOGADOS_FAILURE,
  payload: { error: message },
});

export const actionAbogadosGet = (params = {}) => {
  return async (dispatch) => {
    try {
      const resp = await api.get("abogados", {
        params,
        headers: authHeader(),
      });
      dispatch(fetchAbogadosSuccess(resp.data));
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "Error al cargar abogados");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

export const actionAbogadosCards = (params = {}) => {
  return async (dispatch) => {
    try {
      const resp = await api.get("abogados/cards", {
        params,
        headers: authHeader(),
      });
      dispatch(fetchAbogadosSuccess(resp.data));
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "Error al cargar abogados");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

export const actionAbogadoGetById = (id) => {
  return async (dispatch) => {
    try {
      const resp = await api.get(`abogados/${id}`, { headers: authHeader() });
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo obtener el abogado");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

export const actionAbogadoCreate = (payload) => {
  return async (dispatch) => {
    try {
      const resp = await api.post("abogados", payload, { headers: authHeader() });
      await dispatch(actionAbogadosGet());
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo crear el abogado");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

export const actionAbogadoUpdateById = (id, payload) => {
  return async (dispatch) => {
    try {
      const resp = await api.patch(`abogados/${id}`, payload, { headers: authHeader() });
      await dispatch(actionAbogadosGet());
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo actualizar el abogado");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

export const actionAbogadoDeleteById = (id) => {
  return async (dispatch) => {
    try {
      await api.delete(`abogados/${id}`, { headers: authHeader() });
      await dispatch(actionAbogadosGet());
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo eliminar el abogado");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

// Legacy code-based actions kept for backwards compatibility
export const actionAbogadoGetByCode = (code) => {
  return async (dispatch) => {
    try {
      const resp = await api.get(`abogados/code/${encodeURIComponent(code)}`, {
        headers: authHeader(),
      });
      return resp.data;
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo obtener el abogado");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

export const actionAbogadoUpdateByCode = (code, payload, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      await api.patch(`abogados/code/${encodeURIComponent(code)}`, payload, {
        headers: authHeader(),
      });
      await dispatch(actionAbogadosGet());
      onDone();
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo actualizar el abogado");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};

export const actionAbogadoDeleteByCode = (code, onDone = () => {}) => {
  return async (dispatch) => {
    try {
      await api.delete(`abogados/code/${encodeURIComponent(code)}`, {
        headers: authHeader(),
      });
      await dispatch(actionAbogadosGet());
      onDone();
    } catch (error) {
      const msg = handleApiError(dispatch, error, "No se pudo eliminar el abogado");
      dispatch(fetchAbogadosFailure(msg));
      throw error;
    }
  };
};
